<template lang="html">
  <div class="ficha-producto">
    <template>
      <section class="banner-intro black animation full-view-intro -middle column-center" :data="id" :style="`background:url(/static/img/productos/${id}/background-intro-ficha.jpg) center bottom/cover`
        ">
        <h1 class="title -intro" v-html="$t(`productos.${id}.nombre`)"></h1>
        <h2 class="subtitle-intro">
          <router-link :to="$t('enlaces.productos')">{{
            $t("vistas.productos_aldonza")
          }}</router-link>
        </h2>
      </section>

      <section class="contenedor-intro-producto animation" :data="id">
        <div class="container row-start">
          <div class="texto">
            <h2 class="title" v-html="$t(`productos.${id}.intro_ficha.titulo`)"></h2>
            <div v-html="$t(`productos.${id}.intro_ficha.cuerpo`)"></div>
            <img class="img-tag" v-if="$t(`productos.${id}.slug`) == 'cava'"
              src="/static/img/productos/cava/v-label-vegano.png" alt="Label vegano" />
          </div>
          <div class="video row-start" v-if="showVideo">
            <video playsinline id="video" preload autoplay>
              <!-- <source :src="'/static/video/producto-'+id+'.webm'" type="video/webm"> -->
              <source :src="'/static/video/producto-' + id + '.mp4'" type="video/mp4" />
              <!-- <source :src="'/static/video/producto-'+id+'.ogv'" type="video/ogg"> -->
            </video>
          </div>
        </div>
      </section>

      <template v-if="id != ''">
        <template v-if="!!textos.productos[id].banner_premios">
          <banner-premios v-if="!!textos.productos[id].banner_premios.premio" :data="id"></banner-premios>
        </template>

        <banner-denominacion v-if="!!textos.productos[id].banner_denominacion" :data="id"></banner-denominacion>
      </template>

      <banner-productos :data="id"></banner-productos>
      <banner-tienda v-if="lang == 'es' && siteMex == false"></banner-tienda>
      <banner-beneficios :data="id"></banner-beneficios>

      <productos-banner></productos-banner>

      <banner-experiencia :data="id"></banner-experiencia>
    </template>
  </div>
</template>

<script lang="js">

import bannerPremios from '@/components/views/productos/banner-premio'
import bannerDenominacion from '@/components/views/productos/banner-denominacion'
import bannerBeneficios from '@/components/views/productos/banner-beneficios'
import bannerTienda from '@/components/views/productos/banner-tienda'
import bannerProductos from '@/components/views/productos/banner-productos'
import bannerExperiencia from '@/components/views/productos/banner-experiencia'

import productosBanner from '@/components/parts/productos-banner'

import { mapGetters } from 'vuex';

export default {
  name: 'ficha-producto',
  mounted() {
    if (window.location.hostname.includes('.com.mx')) {
      this.siteMex = true
    }
    this.setSeo();
    this.setID();
    setTimeout(e => {
      this.waypoints();
    }, 100)

  },
  data() {
    return {
      id: '',
      showVideo: false,
      porcentaje: 0,
      siteMex: false
    }
  },
  computed: {
    ...mapGetters({
      textos: 'getTexts',
      lang: 'getLanguage'
    }),
    isMobile: function () {
      let mobileList = ['Android', 'webOS', 'iPhone', 'iPad', 'iPod', 'BlackBerry', 'Windows Phone'];
      let is = false;

      mobileList.forEach(e => {
        if (navigator.userAgent.match(e)) {
          is = true;
        }
      })

      return false;
    }
  },
  methods: {
    setSeo: function () {
      // document.title = this.textos.productos[this.id].nombre;
      // document.head.querySelector("[name=description]").content = this.textos.productos[this.id].intro_productos;
    },
    setID: function () {

      this.showVideo = false;

      let params = {
        "vino": "vino",
        "cava": "cava",
        "aceite": "aceite",
        "azafran": "azafran",
        "wine": "vino",
        "sparkling-wine": "cava",
        "olive-oil": "aceite",
        "saffron": "azafran",
        "queso": "queso",
        "cheese": "queso"
      }

      this.id = params[this.$route.params.id];

      setTimeout(e => {
        this.showVideo = true;
      }, 500)

    },
    waypoints: function () {
      var waypoints = document.getElementsByClassName('animation');
      for (var i = 0; i < waypoints.length; i++) {
        new Waypoint({
          element: waypoints[i],
          offset: '70%',
          handler: function () {
            this.element.classList.add("launched")
          }
        });
      }
    },
  },
  components: {
    'productos-banner': productosBanner,
    'banner-premios': bannerPremios,
    'banner-productos': bannerProductos,
    'banner-denominacion': bannerDenominacion,
    'banner-beneficios': bannerBeneficios,
    'banner-experiencia': bannerExperiencia,
    'banner-tienda': bannerTienda,
  },
  watch: {
    '$route': function () {
      this.setID();
      this.setSeo();
      $(".launched").each(function (index, el) {
        $(this).removeClass('launched')
      });
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/colors.scss";

.full-view-intro {
  background: red;
}

.contenedor-intro-producto {
  background: black;
  padding: 130px 0 160px 0;
  position: relative;
  overflow: hidden;

  .texto {
    max-width: 500px;
    position: relative;
    z-index: 3;
  }

  .title {
    transform: translateY(-300px);
    opacity: 0;
    transition: 1s;
    transition-delay: 1.4s;
  }

  .video {
    width: 50%;
    position: absolute;
    right: 0;
    height: 100%;
    top: 0;
    padding-left: 100px;
    /*background: red;*/

    video {
      width: auto;
      height: 100%;
      display: block;
    }
  }

  .img-tag {
    max-width: 90px;
    display: flex;
    margin-top: 30px;
  }

  &[data="aceite"]::before {
    background: #000 url(/static/img/productos/aceite/background-texto-intro.png) center right/auto 100% no-repeat;
  }

  &[data="azafran"] {
    padding-bottom: 150px;
  }

  &[data="azafran"]::before {
    bottom: 50px;
    background: #000 url(/static/img/productos/azafran/background-texto-intro.png) center right/auto 100% no-repeat;
  }

  &[data="vino"]::before {
    background: #000 url(/static/img/botella-aldonza-small.jpg) center right/auto 100% no-repeat;
  }

  &[data="cava"]::before {
    background: #000 url(/static/img/productos/cava/background-texto-intro.png) center right/auto 100% no-repeat;
  }

  &.launched {

    .title,
    p {
      transform: translateY(0);
      opacity: 1;
    }

    &::before {
      opacity: 1;
    }
  }
}

@media screen and (max-width: 1170px) {
  .contenedor-intro-producto video {
    width: 50%;
  }
}

@media screen and (max-width: 900px) {
  .contenedor-intro-producto .video {
    right: 0;

    &::before {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      content: "";
      display: inline-block;
      background: rgba(0, 0, 0, 0.4);
      z-index: 2;
    }

    video {
      transform: translateX(300px);
    }
  }
}

@media screen and (max-width: 767px) {
  .contenedor-intro-producto .video {
    display: none;
  }
}

@media screen and (max-width: 700px) {
  .contenedor-intro-producto {
    padding: 50px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/productos/ficha.vue